// src/components/practices/MagicFootsteps.js
// Magic Footsteps — a Real-Life/Lightweight Practice: it happens away from the phone, so the
// phone's only job is to teach it and get out of the way. Per spec: no writing fields, no
// tracking, no multiple screens. One instructional screen with a single "Begin ✦" CTA that
// exits the flow immediately — there is nothing to save and nothing to complete here, so unlike
// every other Practice so far, this component makes no practice_completions insert and never
// renders PracticeComplete.
import React from 'react'
import PageHeader from '../ui/PageHeader'
import PrimaryButton from '../ui/PrimaryButton'
import './shared/PracticeHeading.css'
import './MagicFootsteps.css'

export default function MagicFootsteps({ practice, onComplete, onBack, augustTheme, onAugustThemeChange }) {
  return (
    <div className="practice-screen" data-city="august">
      <PageHeader
        eyebrow={`Day ${practice.unlockDay} · ${practice.name}`} title="Take Gratitude With You"
        showBack onBack={onBack}
        augustTheme={augustTheme} onAugustThemeChange={onAugustThemeChange}
      />
      <div className="practice-screen-body footsteps-body">
        <p className="practice-intro-copy footsteps-prompt">
          As you walk today, use your footsteps as a reminder to think or quietly say:
        </p>

        <p className="practice-mantra">Thank you. Thank you. Thank you.</p>

        <PrimaryButton onClick={onComplete}>
          <span>Begin</span>
          <span>✦</span>
        </PrimaryButton>
      </div>
    </div>
  )
}
